import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Input, Row, Col } from 'antd';
import { reduxForm } from 'antd-form-redux';
import { styleGutterRow } from '../../common/configConstants';

export class FormRegistro extends Component {
  static propTypes = {
    parametrosSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = () => {
    this.props.submitForm(this.props.form);
  };

  render() {
    const {
      formRef,
      parametrosSistema,
      form: { getFieldDecorator },
    } = this.props;
    return (
      <div className="parametros-sistema-form-registro">
        <Form layout="vertical" ref={formRef} onSubmit={this.handleSubmit}>
          <Row gutter={styleGutterRow}>
            <Col span={24}>
              <Form.Item label="Valor">
                {getFieldDecorator('Valor', {
                  initialValue: parametrosSistema.registro.Valor,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(<Input placeholder={parametrosSistema.registro.Valor} />)}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    parametrosSistema: state.parametrosSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

FormRegistro = reduxForm({
  form: 'Editar-Parametros',
})(FormRegistro);

FormRegistro = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormRegistro);

export default FormRegistro;



// WEBPACK FOOTER //
// ./src/features/parametros-sistema/FormRegistro.js